import { render, staticRenderFns } from "./Intro.vue?vue&type=template&id=38561df7&scoped=true&"
import script from "./Intro.vue?vue&type=script&lang=ts&"
export * from "./Intro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38561df7",
  null
  
)

export default component.exports